import * as React from "react";
import { IScenarioState } from "./Scenario";


export interface ICurrentPlayerSelectorProps {
    state: IScenarioState;
    onChanged: () => void;
}
export class CurrentPlayerSelectorComponent extends React.Component<ICurrentPlayerSelectorProps, any> {
    selectPlayer(playerNo: number) {
        if (playerNo !== this.props.state.currentSelectedInvestigator) {
            this.props.state.currentSelectedInvestigator = playerNo;
            this.props.onChanged();
        }
    }
    switchPlayerIfCurrentIsResigned() {
        const ss = this.props.state;
        if (!ss.investigators[ss.currentSelectedInvestigator].resigned) return;
        let index = -1;
        for (let i = 0; i < ss.investigators.length; i++) {
            if (!ss.investigators[i].resigned) {
                index = i;
                break;
            }
        }
        if (index > -1) {
            ss.currentSelectedInvestigator = index;
            this.props.onChanged();
        }
    }
    render() {
        window.setTimeout(() => { this.switchPlayerIfCurrentIsResigned(); }, 500);
        const list = this.props.state.investigators.map((inv, i) => {
            var cssClass = "";
            if (this.props.state.currentSelectedInvestigator === i) {
                cssClass = "active";
            }
            if (inv.resigned) {
                cssClass = "resigned";
            }
            return (<li key={i} className={cssClass} onClick={() => { if (!inv.resigned) this.selectPlayer(i); }}>{inv.card.name}</li>);
        });

        return (
            <div id="currentPlayerSelector">
                <ul className="active-selector">{list}</ul>
            </div>
        );
    }
}
